module.exports = __webpack_public_path__ + "img/gigwidog4.3549d297.jpg";